/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EventSceneManagementListInitResponse } from './EventSceneManagementListInitResponse';

export type EventSceneManagementListInitResponseApiRespoonse = {
    data?: EventSceneManagementListInitResponse;
    status?: EventSceneManagementListInitResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace EventSceneManagementListInitResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

